/**
 * @description
 * Objeto Avis
 */

import { AvisCategoria } from "./aviscategoria.model";
import { AvisEstat } from "./avisestat.model";
import { AvisTipus } from "./avistipus.model";
import { AvisTipusEnviament } from "./avistipusenviament.model";

export class Avis {
    public id:number = null;
    public avisCategoria: AvisCategoria = new AvisCategoria();
    public avisTipus: AvisTipus = new AvisTipus();
    public numIdentPers:string = "";
    public dboidPers:string = "";
    public mail:string = "";
    public telfMobil:string = "";
    public avisEstat:AvisEstat = new AvisEstat();
    public dateCreation:Date;
    public dateSend:Date;
    public infoExtra:string = "";
    public error:number;
    public avisTipusEnviament:AvisTipusEnviament = new AvisTipusEnviament();
    public avRead:number;
    public procesExecCreatId:number;
    public infoDetail:string;
    public procesExecSendId:number;
    public remesaSmsId:number;

    constructor() {}
}